export const SITE_URL = "https://thatswhatshisaid.com";
export const OG_IMAGE = SITE_URL + "/og-image.jpg";

export const PREMIERE = {
  programLabel: "Program 001",
  iso: "2026-12-03T08:29:00-05:00",
};
export const WATCH_PROGRAM_001_URL = "https://www.youtube.com/@thatswhatshisaidshow";
